import { render, staticRenderFns } from "./Sorry.vue?vue&type=template&id=54dd240a&scoped=true"
import script from "./Sorry.vue?vue&type=script&lang=js"
export * from "./Sorry.vue?vue&type=script&lang=js"
import style0 from "./Sorry.vue?vue&type=style&index=0&id=54dd240a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dd240a",
  null
  
)

export default component.exports